import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=0569e66c&"
import script from "./Lottery.vue?vue&type=script&lang=ts&"
export * from "./Lottery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports